"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionStandardSetSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
class RegionStandardSetSerializer extends dp_http_client_lib_1.PageableSerializer {
    serializeOne(item) {
        return {
            id: item.id,
            districtId: item.districtId,
            regionId: item.regionId,
            scope: item.scope,
            settingsKey: item.settingsKey,
            standardSetGlobalIds: item.standardSetGlobalIds || [],
            standardSets: item.standardSets || [],
            defaultStandardSet: item.defaultStandardSet,
            subjects: item.subjects,
        };
    }
}
exports.RegionStandardSetSerializer = RegionStandardSetSerializer;
//# sourceMappingURL=region-standard-set.serializer.js.map